import React from 'react';
import { useIntl } from 'react-intl';

import {
    CSSEditor,
    CSSEditorComponentLabel,
    CSSEditorComponentWrapper,
    CSSEditorWidgetProperties,
} from 'components/Editors/components/Editor.style';

import { EditorInput } from 'components/Editors/components/EditorInput';

import { WidgetPresenceContent, WidgetEditorActions } from 'jamespot-user-api';

import { EditorCheckbox } from 'components/Editors/components/EditorCheckbox';

export const JRCWidgetPresenceEditor = ({
    closing,
    limit,
    limitValue,
    onChange,
}: WidgetPresenceContent & WidgetEditorActions<WidgetPresenceContent>) => {
    const intl = useIntl();

    return (
        <CSSEditor>
            <CSSEditorWidgetProperties>
                <CSSEditorComponentWrapper>
                    <CSSEditorComponentLabel>
                        {intl.formatMessage({ id: 'WIDGET_Survey_Closing' })}
                    </CSSEditorComponentLabel>
                    <EditorCheckbox
                        initialValue={!!closing}
                        onChange={(closing) => onChange({ closing, isClosed: false })}
                    />
                </CSSEditorComponentWrapper>
                <CSSEditorComponentWrapper>
                    <CSSEditorComponentLabel>
                        {intl.formatMessage({ id: 'WIDGET_Presence_Limit' })}
                    </CSSEditorComponentLabel>
                    <EditorCheckbox initialValue={!!limit} onChange={(limit) => onChange({ limit })} />
                </CSSEditorComponentWrapper>
                {limit && (
                    <CSSEditorComponentWrapper>
                        <EditorInput
                            label={intl.formatMessage({ id: 'WIDGET_Presence_Limit_Value' })}
                            initialValue={String(limitValue)}
                            onChange={(limitValue) => onChange({ limitValue: Number(limitValue) })}
                        />
                    </CSSEditorComponentWrapper>
                )}
            </CSSEditorWidgetProperties>
        </CSSEditor>
    );
};
